import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { VolumePreview } from './components/VolumePreview';
import { Bonuses } from './components/Bonuses';
import { LookInside } from './components/LookInside';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { shortTestimonials, moreTestimonials } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-plum text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="3ml14faz09sk2">
      <MetaPixel data-id="element-1" data-mp="3rbznujfaj6rj" />
      <main data-id="element-2" data-mp="3rdkh85pvcjnt">
        <Hero data-id="element-3" data-mp="3rd1azm9kzjpm" />
        <SocialProofBar data-id="element-4" data-mp="3recbnd7qcbci" />
        <PainGrid data-id="element-5" data-mp="5orh0l86u6j" />
        <ProductReveal data-id="element-6" data-mp="6801qozk67w" />
        <Tomes data-id="element-7" data-mp="5gfrc0u9uwx" />
        <VolumePreview data-id="element-8" data-mp="82lr78302d1" />
        <Bonuses data-id="element-9" data-mp="2zl3c5m4yv85u" />
        <LookInside data-id="element-10" data-mp="2zllcouynw8jk" />
        <ValueStack data-id="element-11" data-mp="2zm4vedw4z0yn" />
        <Urgency data-id="element-12" data-mp="2zmwj72jhrued" />
        <Pricing data-id="element-13" data-mp="2zng0qi58cgrv" />
        <Testimonials testimonials={shortTestimonials} background="white" data-id="element-14" data-mp="33mf25srr5vek" />
        <Guarantee data-id="element-15" data-mp="33orkw85c49so" />
        <Faq data-id="element-16" data-mp="38m1fs3bhtdnw" />
        <Testimonials testimonials={moreTestimonials} title="More studios, more seasons" background="blush" data-id="element-17" data-mp="38l8hlqqlnwhd" />
        <CostOfInaction data-id="element-18" data-mp="3dm5ze27p6oic" />
        <Close data-id="element-19" data-mp="nvj5hlha6osd" />
      </main>
      <Footer data-id="element-20" data-mp="nwc2vvuco1xu" />
      <PurchaseNotifications data-id="element-21" data-mp="nur7k407oeyx" />
    </div>;
}